import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Handshake } from 'lucide-react';
export const Partners = () => {
  const partners = [{
    name: 'Not A Flower Girl Ltd.',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fzw81HLpEsCdXEuQ5n5hSj/2.png',
    description: 'Leading creative agency supporting cultural initiatives.'
  }, {
    name: 'Brooks & Brown',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/o3ypkjhB7kJ2Wy5Za65rMU/3.png',
    description: 'Consulting firm specializing in community development.'
  }, {
    name: 'Andre MORE Ideation',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rAwr3ugU2e9fekWEX2roAw/4.png',
    description: 'Innovation hub for emerging entrepreneurs.'
  }, {
    name: 'The Work Haven',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qnj3kw6MbAbRKB8AWygyGk/5.png',
    description: 'Co-working space and community for professionals.'
  }];
  return <div className="pt-20" data-id="element-2308">
      <section className="py-16 bg-secondary/5" data-id="element-2309">
        <div className="container mx-auto px-4" data-id="element-2310">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2311">
            Our Partners
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2312">
            We collaborate with forward-thinking organizations to create more
            opportunities, resources, and connections for our community members.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2313">
        <div className="container mx-auto px-4" data-id="element-2314">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-2315">
            {partners.map((partner, index) => <Card key={index} className="p-6 flex flex-col items-center" data-id="element-2316">
                <div className="h-24 mb-6 flex items-center justify-center" data-id="element-2317">
                  <img src={partner.logo} alt={partner.name} className="max-h-full max-w-full object-contain" data-id="element-2318" />
                </div>
                <h3 className="text-xl font-bold text-secondary-dark mb-2 text-center" data-id="element-2319">
                  {partner.name}
                </h3>
                <p className="text-secondary text-center mb-4" data-id="element-2320">
                  {partner.description}
                </p>
              </Card>)}
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200" data-id="element-2321">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-2322">
              <div className="md:w-2/3" data-id="element-2323">
                <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-2324">
                  Become a Partner
                </h2>
                <p className="text-secondary mb-6" data-id="element-2325">
                  Partner with The Networking Salon to co-create events, share
                  resources, and connect with our global community of
                  professionals and changemakers. We're always looking for
                  organizations that align with our mission of building
                  meaningful connections and creating opportunities.
                </p>
                <div className="flex flex-wrap gap-4" data-id="element-2326">
                  <Button data-id="element-2327">
                    <Mail className="mr-2" size={18} data-id="element-2328" />
                    Contact Us
                  </Button>
                  <Button variant="outline" data-id="element-2329">
                    <Handshake className="mr-2" size={18} data-id="element-2330" />
                    Partnership Guide
                  </Button>
                </div>
              </div>
              <div className="md:w-1/3 border-2 border-gray-300 rounded-lg p-4 bg-white" data-id="element-2331">
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-2332">
                  Partnership Benefits
                </h3>
                <ul className="space-y-2" data-id="element-2333">
                  <li className="flex items-start" data-id="element-2334">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-2335"></div>
                    <span data-id="element-2336">Access to our global network</span>
                  </li>
                  <li className="flex items-start" data-id="element-2337">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-2338"></div>
                    <span data-id="element-2339">Co-branded events and content</span>
                  </li>
                  <li className="flex items-start" data-id="element-2340">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-2341"></div>
                    <span data-id="element-2342">Visibility with our community</span>
                  </li>
                  <li className="flex items-start" data-id="element-2343">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary mt-2 mr-2" data-id="element-2344"></div>
                    <span data-id="element-2345">Resource sharing opportunities</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};